import { render, staticRenderFns } from "./SectorDistribution.vue?vue&type=template&id=6ae146ed&scoped=true&"
import script from "./SectorDistribution.vue?vue&type=script&lang=js&"
export * from "./SectorDistribution.vue?vue&type=script&lang=js&"
import style0 from "./SectorDistribution.vue?vue&type=style&index=0&id=6ae146ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae146ed",
  null
  
)

export default component.exports